export const profile = {
  name: "Airton Domiciano",
  intro: {
    greeting: "Hi, I'm",
    role: "Full Stack Developer",
    blurb:
      "I develop and evolve complete digital products, connecting technology, UX, and strategy to deliver consistent and scalable results",
    itemsIntro: [
      "+7 years building web products with a focus on results.",
      "Integrate front and back-end ensuring performance and maintenance.",
    ],
    imageAlt: "Airton in space",
    buttonsLabel: "Professional profiles",
  },
  btnGithub: "View GitHub",
  btnDownloadCV: "Download CV",
  btnLinkedIn: "Connect on LinkedIn",

  about: {
    title: "About Me",
    md: "about-me.md",
    type: "about",
    description:
      "I am a full-stack developer driven by challenges and continuous growth. I focus on building robust, scalable systems and efficient interfaces, always prioritizing organization, quality, and outcomes. I believe good code goes beyond the technical delivery - it brings clarity, purpose, and business impact. I value collaboration, ongoing learning, and best practices, contributing to teams that pursue excellence and constant improvement.",
    terminal: {
      user: "airton@portfolio",
      command: "cat about-me.md",
    },
    imageAlt: "About: static visual",
    focusAreas: [
      {
        label: "Stack",
        value: "Angular / React / NestJS / GraphQL / TypeORM / Node.js / Docker",
      },
      {
        label: "Specialty",
        value: "Modular ERP development, automations, and scalable integrations",
      },
      {
        label: "Routine",
        value: "Code reviews, testing, metrics, and collaboration in agile squads (Scrum/Kanban)",
      },
    ],
    badge: {
      icon: "*",
      label: "Journey in focus",
    },
    highlights: [
      "Transform ideas into fast, secure, and easy-to-maintain solutions.",
      "Define standards and review code to ensure quality in every delivery.",
      "Coordinate teams with a focus on productivity and good communication.",
      "Help new developers grow and always seek to evolve with new challenges.",
    ],
    tags: ["Mentorship & technical leadership", "Open to global opportunities"],
  },
  
};
